export default "__VITE_ASSET__DyuiymVM__"